import { v4 as uuidv4 } from 'uuid';

const DATE_SUFFIX_REGEX = /-\d{4}-\d{2}-\d{2}$/;
const UUID_SUFFIX_REGEX =
  /-[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const stripSuffix = (referenceId: string): string => {
  // For campaigns we suffix the date to the reference id
  if (DATE_SUFFIX_REGEX.test(referenceId)) {
    return referenceId.replace(DATE_SUFFIX_REGEX, '');
  }

  // Otherwise, when we duplicate, we suffix the uuid
  if (UUID_SUFFIX_REGEX.test(referenceId)) {
    return referenceId.replace(UUID_SUFFIX_REGEX, '');
  }

  return referenceId;
};

export const generateReferenceIdForDuplicate = (
  referenceId: string,
): string => {
  const stripped = stripSuffix(referenceId);
  const newUuid = uuidv4();
  return `${stripped}-${newUuid}`;
};
